"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.de = void 0;
exports.de = {
  "consentSettings": {
    "acceptSelected": "Auswahl speichern",
    "title": "Einstellungen",
    "description": "Hier kannst du deine Einstellung zur Verwendung externer Dienste anpassen.",
    "disableAll": {
      "title": "Alle Dienste aktivieren/deaktivieren",
      "description": "Mit diesem Schalter kannst du alle Dienste aktivieren oder deaktivieren."
    },
    "close": "Schließen",
    "save": "Auswahl Speichern",
    "acceptAll": "Alle akzeptieren",
    "info": "Info",
    "showServices": "Dienste anzeigen",
    "decline": "Ablehnen",
    "optOut": {
      "description": "Dieser Dienst wird standardmäßig aktiviert, kann aber jederzeit deaktiviert werden.",
      "title": "(opt-out)"
    },
    "contextOnly": {
      "description": "Dieser Dienst kann nur im Kontext des geblockten Elements auf der Seite aktiviert werden.",
      "title": "(kontextbezogene Zustimmung)"
    },
    "required": {
      "description": "Dieser Dienst ist zwingend erforderlich und kann nicht deaktiviert werden.",
      "title": "(erforderlich)"
    }
  },
  "consentNotice": {
    "changeDescription": "Seit Ihrem letzten Besuch gab es Änderungen, bitte erneuern Sie Ihre Zustimmung.",
    "description": "Du kannst deine Einstellungen jederzeit ändern. Wir verwenden Drittanbieter-Dienste für:",
    "consentSettingsLink": "Einstellungen",
    "title": "Wir verwenden Cookies",
    "acceptAll": "Alle akzeptieren",
    "decline": "Ablehnen",
    "acceptSelected": "Auswahl speichern"
  },
  "language": "Sprache",
  "languageName": "Deutsch",
  "attribution": {
    title: "Consent von Bryn",
    url: "https://brynlabs.com/consent"
  },
  "privacyPolicy": {
    "title": "Datenschutzerklärung",
    "url": ""
  },
  "purposes": {
    "advertising": {
      "description": "Diese Dienste verarbeiten persönliche Informationen, um Ihnen personalisierte oder interessenbezogene Werbung zu zeigen.",
      "title": "Werbung"
    },
    "analytics": {
      "description": "Diese Dienste verarbeiten personenbezogene Daten, um uns zu helfen, unsere Nutzer zu verstehen und diese Website zu verbessern.",
      "title": "Analyse"
    },
    "functionality": {
      "description": "Diese Dienste sind für die korrekte Funktion dieser Website unbedingt erforderlich. Sie können sie hier nicht deaktivieren, da der Dienst sonst nicht richtig funktionieren würde.",
      "title": "Funktionalität"
    },
    "personalisation": {
      "description": "Diese Dienste verarbeiten personenbezogene Daten, um den auf dieser Website angebotenen Service zu optimieren.",
      "title": "Personalisierung"
    },
    "security": {
      "description": "Diese Dienste ermöglichen Benutzerauthentifizierung, Betrugsprävention und andere Maßnahmen zum Schutz der Nutzer.",
      "title": "Sicherheit"
    },
    "other": {
      "description": "Andere Dienste, die nicht weiter kategorisiert wurden.",
      "title": "Andere"
    }
  },
  "readingDirection": "ltr"
};